import { useEffect, useState } from "react";
import { Layout } from "./components/Layout";
import NotFound from "./pages/NotFound";
import { routes } from "./routes";

function scrollInstantly(scrollX, scrollY) {
  const root = document.documentElement;
  const previousBehavior = root.style.scrollBehavior;
  root.style.scrollBehavior = "auto";
  window.scrollTo(scrollX, scrollY);
  root.style.scrollBehavior = previousBehavior;
}

function scrollToHash(hash) {
  if (!hash) return false;
  const target = document.getElementById(decodeURIComponent(hash.slice(1)));
  if (!target) return false;
  target.scrollIntoView({ block: "start" });
  return true;
}

export default function App() {
  const [path, setPath] = useState(window.location.pathname.replace(/\/$/, "") || "/");
  useEffect(() => {
    const previousScrollRestoration = history.scrollRestoration;
    history.scrollRestoration = "manual";
    const onPop = (event) => {
      setPath(window.location.pathname.replace(/\/$/, "") || "/");
      const scrollX = Number(event.state?.scrollX) || 0;
      const scrollY = Number(event.state?.scrollY) || 0;
      const restoreScroll = () => scrollInstantly(scrollX, scrollY);
      requestAnimationFrame(() => requestAnimationFrame(restoreScroll));
      window.setTimeout(restoreScroll, 120);
      window.setTimeout(restoreScroll, 420);
    };
    window.addEventListener("popstate", onPop);
    return () => {
      history.scrollRestoration = previousScrollRestoration;
      window.removeEventListener("popstate", onPop);
    };
  }, []);
  useEffect(() => {
    if (!window.location.hash) return;
    const restoreHash = () => scrollToHash(window.location.hash);
    requestAnimationFrame(() => requestAnimationFrame(restoreHash));
    window.setTimeout(restoreHash, 120);
  }, []);
  const Page = routes[path] || NotFound;
  // 라우트 키는 슬래시 없는 형태이므로 주소창의 /about/ 을 정규화해 조회합니다.
  return <Layout path={path} navigate={(href) => {
    const targetUrl = new URL(href, location.href);
    history.replaceState({ ...history.state, scrollX: window.scrollX, scrollY: window.scrollY }, "", location.href);
    history.pushState({ from: `${location.pathname}${location.search}${location.hash}` }, "", `${targetUrl.pathname}${targetUrl.search}${targetUrl.hash}`);
    setPath(targetUrl.pathname.replace(/\/$/, "") || "/");
    if (targetUrl.hash) {
      const moveToTarget = () => scrollToHash(targetUrl.hash);
      requestAnimationFrame(() => requestAnimationFrame(moveToTarget));
      window.setTimeout(moveToTarget, 120);
    } else {
      scrollInstantly(0, 0);
    }
  }}><Page /></Layout>;
}
